module.exports = __webpack_public_path__ + "img/quizz.23e98fcf.jpg";